import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
// eslint-disable-next-line max-len
import { HealthServiceCoreFeaturesMedicalExaminationApiModelsMedicalExaminationDto } from '@sdir/httpclient/lib/clients/aps/health';

type LimitationsSummaryProps = {
  examination?: HealthServiceCoreFeaturesMedicalExaminationApiModelsMedicalExaminationDto | null;
};

const LimitationsSummary: React.FC<LimitationsSummaryProps> = ({ examination }) => {
  const intl = useIntl();

  if (examination?.noFitnessLimitations) return <></>;

  return (
    <Content>
      <ContentTitle>
        {intl.formatMessage({ id: 'competence.table.health.limitations' })}
      </ContentTitle>
      {(examination?.limitations || []).map((l) => (
        <Limitation>
          {intl?.locale === 'no' ? l?.descriptionNorwegian : l.descriptionEnglish || ''}
        </Limitation>
      ))}
    </Content>
  );
};

export default LimitationsSummary;

const Content = styled.div`
  margin-top: 30px;
  text-align: left;
`;
const ContentTitle = styled.div`
  font-weight: 600;
  margin-bottom: 5px;
`;
const Limitation = styled.div`
  margin-top: 5px;
`;
